import React from "react";

import DataTable from "../ui/DataTable";

export default function LeadTable({
  filteredLeads,
  getBadgeStyle,
  onSelectLead
}) {
  const columns = [
    {
      key: "createdAt",
      label: "Date",
      render: (lead) =>
        lead.createdAt
          ? new Date(lead.createdAt).toLocaleDateString()
          : "-"
    },
    { key: "name", label: "Name" },
    { key: "company", label: "Company" },
    { key: "email", label: "Email" },
    {
      key: "companySize",
      label: "Size",
      render: (lead) => lead.companySize || "-"
    },
    {
      key: "score",
      label: "Score",
      render: (lead) => <strong>{lead.score}</strong>
    },
    {
      key: "temperature",
      label: "Status",
      render: (lead) => (
        <span style={getBadgeStyle(lead.temperature)}>
          {lead.temperature}
        </span>
      )
    },
    {
      key: "stage",
      label: "Pipeline",
      render: (lead) => lead.stage || "New"
    },
    { key: "interest", label: "Interest" },
    {
      key: "owner",
      label: "Owner",
      render: (lead) => lead.owner || "-"
    },
    {
      key: "nextFollowUp",
      label: "Next Follow-Up",
      render: (lead) =>
        lead.nextFollowUp
          ? new Date(lead.nextFollowUp).toLocaleDateString()
          : "-"
    },
    {
      key: "message",
      label: "Message",
      render: (lead) => lead.message || "-"
    }
  ];

  return (
    <DataTable
      columns={columns}
      data={filteredLeads || []}
      onRowClick={onSelectLead}
      getRowKey={(lead, index) => lead._id || lead.id || index}
      emptyTitle="No leads found"
      emptyMessage="No lead records are currently available."
    />
  );
}